import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Leaderboard from "../components/Leaderboard/Leaderboard";
import LeaderBoardItem from "../components/Leaderboard/LeaderBoardItem";
import SectionSpinner from '../components/Loading/SectionSpinner/SectionSpinner';

import "./Leaderboard.css";
import Logo from '../assets/images/rezzil-logo-full.png';

function LeaderBoardPage() {

    const [leaderboardData, setLeaderboardData] = useState();
    const [loading, setLoading] = useState(true);

    const [latestOpacity, setLatestOpacity] = useState(0);
    const [latestPlayer, setLatestPlayer] = useState({rank:'', userPlatformName:'', score:''});

    const [searchParams, setSearchParams] = useSearchParams();

    var leaderboard_id = "";
    var challenge_id = "";
    var autoupdate;

    if(searchParams.get("leaderboard")!==null){
        leaderboard_id = searchParams.get("leaderboard");
    }
    else{
        leaderboard_id = process.env.REACT_APP_LEADERBOARD_NAME;
    }  


    function getLeaderboardData(){
        
        var leaderboard_url = process.env.REACT_APP_LEADERBOARD_API_ENDPOINT + "leaderboards/top/" + leaderboard_id + "/" + process.env.REACT_APP_LEADERBOARD_KEY + "/20";

        return fetch(leaderboard_url, {
            method: 'GET',
            headers: {
            'Content-Type': 'application/json'
            }
        })
        .then(res => res.json())
        .then(function (data){
    
            if(data.code === 200){
                setLeaderboardData(data.data);
                setLoading(false);
            }else{
                console.log("[LOG] An error occured loading the leaderboard.");
                return false;
            }        
        })
    }

    function getLastPlayer(){

        var data_url = process.env.REACT_APP_API_ENDPOINT + "squadslive/challenges";

        return fetch(data_url, {
            method: 'GET',
            headers: {
            'Content-Type': 'application/json'
            }
        })
        .then(res => res.json())
        .then(function (data){
    
            if(data.code === 200){

                data.data.forEach(challenge_data => {
                    const challengeId = challenge_data.challenge_id.toString();
                    if(challengeId === challenge_id){
                        getLastPlayerData(challenge_data.user.id);
                    }
                });

            }else{
                console.log("[LOG] An error occured loading the latest user.");
                setLatestOpacity(0);
                return false;
            }        
        });

        
        

    }

    function getLastPlayerData(last_player_id){

        var event_player_id = process.env.REACT_APP_USER_LEADERBOARD_PREFIX + last_player_id;
        var data_url = process.env.REACT_APP_LEADERBOARD_API_ENDPOINT + "leaderboards/around/" + leaderboard_id + "/" + event_player_id + "/" + process.env.REACT_APP_LEADERBOARD_KEY + "/1";

        console.log(data_url)

        return fetch(data_url, {
            method: 'GET',
            headers: {
            'Content-Type': 'application/json'
            }
        })
        .then(res => res.json())
        .then(function (data){
    
            if(data.code === 200){
                // Check if the entry we got back is for the ID we just used
                console.log(data.data.entries[0]);
                if(data.data.entries[0].userPlatformId === event_player_id){

                    setLatestPlayer(
                                        {
                                            rank: data.data.entries[0].rank,
                                            userPlatformName:data.data.entries[0].userPlatformName,
                                            score: data.data.entries[0].score
                                        }
                                    );
                    setLatestOpacity(1);

                }
                else{
                    console.log("[LOG] userPlatformId: " + data.data.entries[0].userPlatformId + " doesn't match " + event_player_id);
                    setLatestOpacity(0);
                }

            }else{
                console.log("[LOG] An error occured loading the leaderboard.");
                return false;
            }        
        });
    }

    function updateData(){
        getLeaderboardData();
        getLastPlayer();
        console.log("[LOG] Update called.");
    }


    useEffect(() => {
        document.title = 'Rezzil';
    
        autoupdate = setInterval(updateData, process.env.REACT_APP_USER_LEADERBOARD_UPDATE_SECONDS*1000);
        updateData();


        if(searchParams.get("challenge")!==null){
            challenge_id = searchParams.get("challenge");
        }

        console.log("[LOG] Leaderboard ID: " + leaderboard_id);
        console.log("[LOG] Challenge ID: " + challenge_id);
        console.log("[LOG] Updating every: " + process.env.REACT_APP_USER_LEADERBOARD_UPDATE_SECONDS + " seconds");

    }, []);

    
    if (loading) {
        return <SectionSpinner />;
    }else{
        return(
            <>
                <div id="leaderboard-bg"></div>
                <div>
                    <div id="leaderboard-title">{leaderboardData.leaderboard.name}</div>

                    <div id="leaderboard">
                        <Leaderboard entries={leaderboardData.entries} />
                    </div>
                    
                </div>

                <div id="logo-container">
                    <img src={Logo} alt='Rezzil Logo' id="logo"/>
                </div>

                <div id="last_player" style={{opacity:latestOpacity}}>
                    <LeaderBoardItem 
                        key={"latest_entry"}
                        data={latestPlayer}
                    />
                </div>

                <div id="leaderboard-logo-scoller">
                </div>
            </>
        )
    }


}

export default LeaderBoardPage;